export const appVersion =
  // @ts-ignore process may be undefined depending on environment
  // eslint-disable-next-line no-undef
  process.env.NODE_ENV === 'production'
    ? import.meta.env.VITE_APP_VERSION || ''
    : 'local'

const environment = import.meta.env.VITE_ENVIRONMENT // local, staging, production

export const isProduction = environment === 'production'
